import { PATHS } from '../constants/paths';

export const oktaConfig = {
  issuer: 'https://spglobal.oktapreview.com/oauth2/default',
  clientId: '0oam3wzx7cVwflf8Y1d7',
  redirectUri: window.location.origin + PATHS.authCallback,
  logoutUrl: window.location.origin + PATHS.login,
  scopes: ['openid', 'profile', 'email', 'offline_access', 'groups'] as string[],
  pkce: true,
} as const;
